// extracted by mini-css-extract-plugin
export default {"deleteIconContainer":"shared_deleteIconContainer__7CqFb","small":"shared_small__ibkMP","urlBox":"shared_urlBox__5HQve"};